import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SearchOffIcon from '@material-ui/icons/YoutubeSearchedForSharp';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import { placeholder } from './constants';
import TextFieldInput from '../../assets/TextFieldInput';
import UserListDesktop from './UserListDesktop';
import UserListMobile from './UserListMobile';
import AlertWrap from './AlertWrap';
import RolesMenu from './RolesMenu';

const userListStyle = makeStyles((theme) => ({
  desktopBox: {
    border: 'none',
    padding: '0',
    bottomPading: '2',
    width: '75%',
  },
  roles: {
    flexBasis: 'content',
    width: '20%',
  },
  mobileBox: {
    border: 'none',
    padding: '0',
    bottomPading: '2',
    flexBasis: 'content',
    width: '100%',
  },
  rolesMobile: {
    width: '100%',
  },
  spreadBox: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  container: {
    margin: theme.spacing(2, 0, 2, 0),
  },
  containerMessage: {
    padding: theme.spacing(2.5),
  },
  secondaryButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.light,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      '@media (hover: none)': {
        backgroundColor: theme.palette.secondary.light,
      },
    },
  },
  actionBox: {
    marginTop: theme.spacing(1),
  },
  actionLine: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  buttonBox: {
    marginTop: theme.spacing(3),
    flexGrow: 1,
  },
  actionButton: {
    maxWidth: '210px',
    minWidth: '210px',
    marginRight: theme.spacing(2),
  },
  descriptionBox: {
    marginRight: theme.spacing(1),
  },
  dividerSection: {
    marginTop: theme.spacing(2),
  },
}));

const UserList = ({
  error, page, list, loading, pageData, handlePagination,
  browserSettings, disableSearch, handleOnClickTable,
  handleOnCLickNewUser, handleOnClickBulkUsers,
  handleOnCLickJobsList, handleOnClickUsersReport,
  alerts, loadingGeneration, jobId, value, onChangeValue,
  rolesList, onChangeRolesFilter, isFilterByRole, usersRequested,
}) => {
  const styles = userListStyle();

  const userListToRender = (
    browserSettings[0].isMobile
      ? (
        <UserListMobile
          error={error}
          page={page}
          list={list}
          loading={loading}
          pageData={pageData}
          handlePagination={handlePagination}
          handleOnClickTable={handleOnClickTable}
          isFilterByRole={isFilterByRole}
          usersRequested={usersRequested}
        />
      )
      : (
        <UserListDesktop
          error={error}
          page={page}
          list={list}
          loading={loading}
          pageData={pageData}
          handlePagination={handlePagination}
          handleOnClickTable={handleOnClickTable}
          isFilterByRole={isFilterByRole}
          usersRequested={usersRequested}
        />
      )
  );

  const actionButtons = (
    <Box className={styles.actionBox}>
      <Box display="flex" className={styles.actionLine}>
        <Box className={styles.actionButton}>
          <Button
            className={styles.secondaryButton}
            disableElevation
            onClick={handleOnCLickNewUser}
            variant="contained"
            fullWidth
          >
            NEW USER
          </Button>
        </Box>
        <Box display="flex" className={styles.descriptionBox}>
          {!browserSettings[0].isMobile && (
          <Typography align="center">
            Single user creation on Auth0
          </Typography>
          )}
        </Box>
      </Box>
      <Box display="flex" className={styles.actionLine}>
        <Box className={styles.actionButton}>
          <Button
            className={styles.secondaryButton}
            disableElevation
            onClick={handleOnClickBulkUsers}
            variant="contained"
            fullWidth
          >
            Bulk Create Users
          </Button>
        </Box>
        <Box display="flex" className={styles.descriptionBox}>
          {!browserSettings[0].isMobile && (
          <Typography align="center">
            Bulk users creation using Auth0 migration tool
          </Typography>
          )}
        </Box>
      </Box>
      <Box display="flex" className={styles.actionLine}>
        <Box className={styles.actionButton}>
          <Button
            className={styles.secondaryButton}
            disableElevation
            onClick={handleOnCLickJobsList}
            variant="contained"
            fullWidth
          >
            JOBS STATUS
          </Button>
        </Box>
        <Box display="flex" className={styles.descriptionBox}>
          {!browserSettings[0].isMobile && (
          <Typography align="center">
            Import / Export Auth0 job status list
          </Typography>
          )}
        </Box>
      </Box>
      <Box display="flex" className={styles.actionLine}>
        <Box className={styles.actionButton}>
          <Button
            className={styles.secondaryButton}
            disableElevation
            onClick={handleOnClickUsersReport}
            variant="contained"
            fullWidth
          >
            CSV REPORT
          </Button>
        </Box>
        <Box display="flex" className={styles.descriptionBox}>
          {!browserSettings[0].isMobile && (
          <Typography align="center">
            Generate users report
          </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box>
      <>
        <Box display={browserSettings[0].isMobile ? 'inline' : 'flex'} justifyContent="space-between">
          <Box display="flex" component="fieldset" className={browserSettings[0].isMobile ? styles.mobileBox : styles.desktopBox}>
            <TextFieldInput
              label="Search"
              variant="filled"
              placeholder={placeholder.SEARCH}
              value={value.searchValue}
              onChange={onChangeValue}
              name="searchValue"
              disabled={disableSearch}
              inputPrefix={false}
              autoComplete
              debounceTime={300}
              debounce
              isMultiline={false}
              processInput={null}
              isFilterByRole={isFilterByRole}
            />
          </Box>
          <Box display="flex" className={browserSettings[0].isMobile ? styles.rolesMobile : styles.roles}>
            <RolesMenu
              filters={rolesList}
              onChangeFilter={onChangeRolesFilter}
            />
          </Box>
        </Box>
        {loading === false && list.length > 0
      && (
        <Box>
          {userListToRender}
        </Box>
      )}
        {loading === false && list.length === 0
      && (
      <Grid container justifyContent="center">
        <Box className={styles.container}>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <SearchOffIcon
                fontSize="large"
              />
            </Grid>
          </Grid>
          <br />
          <Typography
            variant="body2"
            component="div"
            alignitems="center"
          >
            No records match the search criteria. Please try again with another value.
          </Typography>
        </Box>
      </Grid>
      )}
      </>
      {loading === false
      && (
        <>
          <Box>
            <Typography align="left" variant="h6">
              Actions
            </Typography>
          </Box>
          <Divider />
          <Box display="flex" className={styles.buttonBox}>
            {actionButtons}
          </Box>
          <Divider className={styles.dividerSection} />
        </>
      )}
      <Container>
        {!loadingGeneration
            && alerts.map((alert) => (
              <AlertWrap
                key={alert}
                element={alert}
                jobId={jobId}
              />
            ))}
      </Container>
    </Box>
  );
};

export default UserList;
